import { useMemo } from 'react'

import { useCubeContext } from 'modules/Cube/communication/internal/cube.domain.context'
import { useQuoteApproval } from 'Cube/domain'
import {
  publishButtonState,
  type PublishButtonState
} from './publishButtonState'

/**
 * Gathers what the publish button's state is worked out from, and hands it to
 * `publishButtonState`. The decision happens there, so it can be read and
 * tested without a quote editor around it.
 */
export const usePublishButtonState = ({
  fallbackText
}: {
  /** What the button says once we know what publishing would do. */
  fallbackText: string
}): PublishButtonState => {
  const ctx = useCubeContext()
  const {
    simulationHasRanAtLeastOnce,
    isSimulationPending,
    simulatedTerminalType
  } = useQuoteApproval()

  const hasActiveApprovalAutomation = Boolean(
    ctx.queries.rawData.data.quote.activeQuoteApprovalAutomationVersionId
  )

  return useMemo(
    () =>
      publishButtonState({
        fallbackText,
        hasActiveApprovalAutomation,
        simulationHasRanAtLeastOnce,
        isSimulationPending,
        simulatedTerminalType
      }),
    [
      fallbackText,
      hasActiveApprovalAutomation,
      simulationHasRanAtLeastOnce,
      isSimulationPending,
      simulatedTerminalType
    ]
  )
}
